import * as service from "./service";
import authCheck from "@/lib/auth";

export default {
    namespaced: true,
    state: {
        menu: {
            time: 0,
            all: 0,
            wait: 0,
            todo: 0,
            done: 0
        },
        me: {}
    },
    mutations: {
        update(state, payload) {
            state.me = payload.me;
            state.menu = payload.menu;
        },
        updateStatus(state, payload) {
            state.me = payload.me;
        }
    },
    actions: {
        async updateStatus({ commit }) {
            const result = {};
            result.me = await service.getMyStatus();
            commit("updateStatus", result);
        },

        async update({ commit }) {
            const menu = {
                time: +new Date()
            };
            const result = { menu };
            let authAction;

            const permits = [
                {
                    permit: "ticket.all",
                    menu: "all"
                },
                {
                    permit: "ticket.unassigned",
                    menu: "wait"
                },
                {
                    permit: "ticket.myopen",
                    menu: "todo"
                },
                {
                    permit: "ticket.myclosed",
                    menu: "done"
                },
                {
                    permit: "ticket.autoreply",
                    menu: "auto"
                }
            ];

            authAction = permits.reduce((res, p) => {
                if (authCheck(p.permit)) {
                    return res ? `${res},${p.menu}` : p.menu;
                }
                return res;
            }, "");

            try {
                await Promise.all(
                    authAction
                        .split(",")
                        .map(async type => {
                            const {
                                pagination: { totalCount }
                            } = await service.list({ action: type, pageSize: 0 });
                            menu[type] = totalCount;
                        })
                        .concat(
                            (async () => {
                                result.me = await service.getMyStatus();
                            })()
                        )
                );
            } catch (err) {
                console.error(err);
            }
            commit("update", result);
        }
    }
};
